import {
  htmlToMarkdown,
  markdownToHtml,
  type MarkdownToHtmlOptions,
} from '@kizen/parse-md';
import { Editor } from '@tiptap/core';

export const getRawTextValue = async (editor: Editor, isMarkdown: boolean) => {
  if (isMarkdown) {
    return htmlToMarkdown(editor.getHTML());
  } else {
    const doc = new DOMParser().parseFromString(editor.getHTML(), 'text/html');
    const paragraphs = Array.from(doc.querySelectorAll('p'));
    const textContent = paragraphs.map((p) => p.textContent).join('\n');
    return textContent;
  }
};

export const getHTMLValue = async (
  value: string,
  isMarkdown: boolean,
  options?: MarkdownToHtmlOptions
) => {
  if (isMarkdown) {
    return markdownToHtml(value, options);
  } else {
    const lines = value.split(/\n/);
    return lines.map((line) => `<p>${line}</p>`).join('');
  }
};
